import { app } from '../../../../../../app';
import { Controller } from './delete-domain.controller';

app.component('companyDirectoryIntegrationManageDomainsDeleteDomain', {
    bindings: {
        companyId: '<',
        directory: '<',
        domain: '<',
    },
    controller: Controller,
    templateUrl: require('./delete-domain.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains/delete-domain/delete-domain.component.js